$(function ($) {

  $('.open-modal').on('click', function(e) {
    e.preventDefault();

    const modal = $(this).data('modal');
    $('.global-overlay').fadeToggle();
    $('body').addClass('overflow-hidden');
    $(`.modal-wrapper[data-modal=${modal}]`).fadeToggle();
  });

  $('.close-modal').on('click', function(e) {
    e.preventDefault();

    $('body').removeClass('overflow-hidden');
    $('.global-overlay').fadeOut();
    $('.modal-wrapper').fadeOut();
  });

  $('.event-block').on('mouseenter', function(e) {
    const event = $(this);
    const href = event.find('.title a').attr('href');
    const img = event.data('img');
    
    if (img) {
      const popover = `
        <div class="event-popover">
          <a href="${href}" class="img-wrapper">
            <img src="${img}" alt="">
          </a>
        </div>
      `
      event.find('.title').prepend(popover);
    }
    
  }).on('mouseleave', function(e) {
    $('body').find('.event-popover').remove();
  });

});
